export enum SalesChannel {
	Egis = 'Synaxon / Egis',
	Octo = 'Octo24 Webshop',
	Conrad = 'Conrad',
	ItScope = 'ITscope Reseller',
	ItScopeB2B = 'ITscope B2B-Suite',
	Nagarro = 'Nagarro',
	Asb = 'Asb',
	Wucato = 'Wucato',
}

export const SalesChannelNavigationPath = new Map<SalesChannel, string>([
	[SalesChannel.Egis, 'egis'],
	[SalesChannel.Octo, 'octo'],
	[SalesChannel.Conrad, 'conrad'],
	[SalesChannel.ItScope, 'itScope'],
	[SalesChannel.ItScopeB2B, 'b2bItScope'],
	[SalesChannel.Nagarro, 'nagarro'],
	[SalesChannel.Asb, 'asb'],
	[SalesChannel.Wucato, 'wucato'],
]);
export const NavigationPathToSalesChannel = new Map<string, SalesChannel>([
	['egis', SalesChannel.Egis],
	['octo', SalesChannel.Octo],
	['conrad', SalesChannel.Conrad],
	['itScope', SalesChannel.ItScope],
	['b2bItScope', SalesChannel.ItScopeB2B],
	['nagarro', SalesChannel.Nagarro],
	['asb', SalesChannel.Asb],
	['wucato', SalesChannel.Wucato],
]);
